import styled from "styled-components";

export const TextInput = styled.p`
  font-size: 1rem;
  color: #999;
`